module.exports = __webpack_public_path__ + "static/media/pic35.d719043a.jpg";